import { Phone, Mail, MapPin } from "lucide-react";
import { Card } from "@/components/ui/card";
const contactItems = [{
  icon: Mail,
  label: "Questions?",
  value: "hello@janeandliam.com"
}, {
  icon: Phone,
  label: "Wedding Planner",
  value: "+1 (555) 012-3456"
}, {
  icon: MapPin,
  label: "Visit Us",
  value: "New York, NY"
}];
export default function ContactDetails() {
  return <section data-section-id="236881" id="reach-out-to-us" className="bg-background text-foreground relative py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-[0.02] bg-[image:radial-gradient(var(--color-foreground)_1px,transparent_1px)] [background-size:48px_48px] pointer-events-none" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_right,var(--color-secondary)_0%,transparent_40%)] opacity-20 pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {contactItems.map((item, i) => {
          const Icon = item.icon;
          const isImage = item.value.startsWith("/img/");
          return <Card key={i} data-index={i} className="bg-card/30 border-border/40 backdrop-blur-sm flex flex-col items-center text-center p-10 hover:border-accent/50 transition-all duration-500 shadow-md rounded-md">
                <div className="mb-6 p-4 rounded-lg bg-secondary/20">
                  <Icon className="w-12 h-12 text-primary" strokeWidth={1} />
                </div>
                <h3 className="text-xs uppercase tracking-widest text-muted-foreground mb-3 font-sans font-medium">
                  {item.label}
                </h3>
                {isImage ? <div className="w-full h-24 overflow-hidden rounded-md">
                    <img src={item.value} alt="Jane and Liam" className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700" />
                  </div> : <p className="text-lg md:text-xl font-medium text-foreground font-default tracking-tight">
                    {item.value}
                  </p>}
              </Card>;
        })}
        </div>
      </div>
    </section>;
}